export function eventTargetNotInTextbox(e) {
  let tagName = e.target.tagName.toLowerCase();
  return tagName !== 'input' && tagName !== 'textarea' && tagName !== 'select';
}
